

const configAdmin = {
  admin: {
    listLayout: "AdminListDefaultLayout",
    filterLayout: "AdminFilterDefaultLayout",
    paginationLayout: "PaginationDefaultLayout",

    getFunc: "getAdmin",
    listApiParamSet: {
      ip: 1,
      sp: 10,
    },
    deleteFunc: 'deleteAdmin',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {
            '-1': "일시적 오류 발생",
            '-100': "필수 값이 없습니다.",
            '-700': "중복된 휴대폰 번호입니다.",
            '-403': "권한이 없습니다.",
        },
        keyName: 'a_idx',
  },
  adminEdit:{
        writeFunc: "updateAdmin",
        writeApiParamSet: {},
        parsingData: {
          nickName: "a_nick",
          phoneNum:'a_hp',
        },
        writeFailTypes: {
          '-1': "관리자 수정에 오류가 발생했습니다.",
          '-100': "필수 값이 없습니다.",
          '-700': "중복된 휴대폰 번호입니다.",
          '-403': "권한이 없습니다.",
      },
        keyName: 'a_idx',
  },
  adminCreate:{
        writeFunc: "createAdmin",
        writeApiParamSet: {},
        parsingData: {
          nickName: "a_nick",
          phoneNum:'a_hp',
        },
        writeFailTypes: {
          '-1': "관리자 등록에 오류가 발생했습니다.",
          '-100': "필수 값이 없습니다.",
          '-700': "중복된 휴대폰 번호입니다.",
          '-403': "권한이 없습니다.",
      },
  }
  
}
export default {
    methods: {
        returnAdminConfig(type) {
            return configAdmin[type];
        },

    },
    filterConfig: {
        cr: {
            type: 'between',
            classname: 'filterDate'
        },
        ni: {
            type: 'query',
            classname: 'searchInput',
        },
        hp: {
            type: 'query',
            classname: 'searchInput',
        },
    }
}
